import AccountCircle from '@mui/icons-material/AccountCircle';
import Email from '@mui/icons-material/Email';
import LocationOn from '@mui/icons-material/LocationOn';
import Person from '@mui/icons-material/Person';
import Public from '@mui/icons-material/Public';
import School from '@mui/icons-material/School';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import SvgIcon, { SvgIconTypeMap } from '@mui/material/SvgIcon';
import Typography from '@mui/material/Typography';
import { HttpClient } from 'apiclient/ApiClient';
import {
    PROFILE_ADDRESS,
    PROFILE_EMAIL,
    PROFILE_NAME,
    PROFILE_POSITION,
    PROFILE_SCHOOL,
    PROFILE_SITE
} from 'config/config';
import { IProfileInfo } from 'models/IProfile';
import IResponse from 'models/IResponse';
import { useQuery } from 'react-query';
import Copyright from 'ui/components/Copyright';


const Record = ({name, data, icon}: {
    name: string,
    data: string,
    icon: OverridableComponent<SvgIconTypeMap<{}, "svg">> & {muiName: string;}
}): JSX.Element => {
    return (
        <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
            <SvgIcon
                sx={{flex: '0 0 50px'}}
                fontSize='large'
                color='secondary'
                component={icon}
            />
            <Box sx={{ flex: '1 1 auto'}}>
                <Typography
                    component="div"
                    variant='caption'
                    color="text.secondary"
                >
                    {name}
                </Typography>
                <Typography component="div" variant="subtitle1">
                    {data}
                </Typography>
            </Box>
        </Box>
    )
};

export default function Profile() {

    const httpClient = HttpClient();
    const resp: IResponse<IProfileInfo> = useQuery(
        '/school/profile', async () => httpClient.get<IProfileInfo>('/school/profile')
    );
    const profileInfo = resp.data;
    return (
        <Container
            maxWidth='lg'
            sx={{
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                pb: 8,
            }}
        >
            <Grid container spacing={2} sx={{mt: 2}}>
                <Grid item md={6} xs={12}>
                    <Card sx={{height: '100%'}}>
                        <CardContent sx={{ display: 'flex', flexDirection: 'column', pt: 3 }}>
                            <Record 
                                name={PROFILE_NAME}
                                data={profileInfo?.name || ''}
                                icon={AccountCircle}
                            />
                            <Record
                                name={PROFILE_EMAIL}
                                data={profileInfo?.email || ''}
                                icon={Email}
                            />
                            <Record
                                name={PROFILE_POSITION}
                                data={profileInfo?.role || ''}
                                icon={Person}
                            />
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item md={6} xs={12}>
                    <Card sx={{height: '100%'}}>
                        <CardContent sx={{ display: 'flex', flexDirection: 'column', pt: 3 }}>
                            <Record 
                                name={PROFILE_SCHOOL}
                                data={profileInfo?.organization_name || ''}
                                icon={School}
                            />
                            <Record
                                name={PROFILE_ADDRESS}
                                data={profileInfo?.organization_location || ''}
                                icon={LocationOn}
                            />
                            <Record
                                name={PROFILE_SITE}
                                data={profileInfo?.organization_website || '–'}
                                icon={Public}
                            />
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
            <Copyright/>
        </Container>
    );
}